jQuery(function($) {
	if (!$('.basic_page_image_grid .slider').length)
		return;

	$('.basic_page_image_grid .slider').on('init', function(event){
		$('.basic_page_image_grid .slider .slick-slide:not(.slick-active)').find('.content_wrapper *:not(object)').attr('tabindex', -1);

		$('.basic_page_image_grid .slider .slick-arrow').on('click', function() {
			setTimeout(function(){
				var currentSlideEl = $('.basic_page_image_grid .slider .slick-active');
				currentSlideEl.find('.content_wrapper *:not(object)').first().focus();
			}, 100);
		});
	});

	initializeSlick('.basic_page_image_grid .slider', {
		accessibility: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		arrows: true,
		autoplay: true,
		fade: true,
		pauseOnFocus: true,
		pauseOnHover: false,
		nextArrow: '<button class="slider_arrow next_arrow white">Next</button>',
		prevArrow: '<button class="slider_arrow prev_arrow white">Previous</button>'
	});

	$('.basic_page_image_grid .slider').on('afterChange', function() {
		setTimeout(function(){
			currentSlideEl = $('.basic_page_image_grid .slider .slick-active');
			$('.basic_page_image_grid .slider .slick-slide').find('.content_wrapper *:not(object)').attr('tabindex', -1);
			currentSlideEl.find('.content_wrapper *:not(object)').attr('tabindex', 0);
		}, 100);
	});
});